import { FormInput } from 'src/@types';
import { getDefaultValue } from 'src/components/shared/form-elements';
import { IncomeCalculatorDefaultFormFields } from '../../../../@types/shared/income-calculator';

export const sharedIncomeCalculatorDefaultFormFields: Record<
  keyof IncomeCalculatorDefaultFormFields,
  FormInput
> = {
  PER: {
    fieldName: 'PER',
    label: 'Hoe vaak ontvang jij je salaris?',
    type: 'radio',
    options: [
      { label: 'één keer per maand', value: '12' },
      { label: 'één keer per 4 weken', value: '13' }
    ],
    defaultValue: getDefaultValue('12')
  },
  INK: {
    fieldName: 'INK',
    label: 'Wat is je bruto salaris?',
    type: 'currency',
    defaultValue: getDefaultValue('2200')
  },
  ORT: {
    fieldName: 'ORT',
    label: 'Hoeveel variabel inkomen ontvang je?',
    type: 'currency',
    tooltip:
      "Een variabel inkomen is loon dat niet vast is, zoals een bonus of commissie. Denk hierbij aan een winstuitkering of prestatiebonus, maar ook aan onregelmatigheidstoeslag of uitbetaalde overwerkuren. Lees <a href='https://www.hypotheker.nl/begrippenlijst/hypotheek-afsluiten/variabel-inkomen/' target='_blank'>hier meer over variabel inkomen.",
    defaultValue: getDefaultValue('200')
  },
  JVA: {
    fieldName: 'JVA',
    label: 'Krijg je vakantiegeld?',
    type: 'radio',
    options: [
      { label: 'Ja', value: '1' },
      { label: 'Nee', value: '2' }
    ],
    defaultValue: getDefaultValue('1')
  },
  DMK: {
    fieldName: 'DMK',
    label: 'Krijg je een 13e maand?',
    type: 'radio',
    options: [
      { label: 'Ja', value: '1' },
      { label: 'Nee', value: '2' }
    ],
    defaultValue: getDefaultValue('1')
  }
};
